class TdOriginChecker extends HTMLElement {
  constructor() {
    super();
    this.COOKIE_NAME = "TDCookie";
    this.COOKIE_VALUE = "here";
    this.EXPIRY_DAYS = 30;
    this.CURRENT_PAGE_HANDLE = window.location.pathname.split("/").pop();
    this.URL_PARAMS = new URLSearchParams(window.location.search);
    this.REFERRAL_SOURCE = document.referrer;
    this.CHILD_SEGMENTS = document.querySelectorAll(".announcement-bar__item");
  }

  connectedCallback() {
    this.displayNextBanner();
    this.checkAnyBannerDisplayed();
    this.updateComponentHeight();
    window.addEventListener("resize", () => this.updateComponentHeight());
  }

  // Publishes the bar height for use by the theme
  updateComponentHeight() {
    const height = this.clientHeight;
    document.documentElement.style.setProperty(
      "--announcement-bar-height",
      `${height}px`
    );
  }

  // Method to get cookie by name
  getCookie(name) {
    const nameEQ = name + "=";
    const ca = document.cookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === " ") c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }

  // Check & set cookie
  checkAndSetCookie() {
    let isCookieSet = false;

    // Check if the cookie exists
    if (this.getCookie(this.COOKIE_NAME)) {
      isCookieSet = true;
    } else {
      // Cookie doesn't exist, so add it
      let expires = "";
      if (this.EXPIRY_DAYS) {
        const date = new Date();
        date.setTime(date.getTime() + this.EXPIRY_DAYS * 24 * 60 * 60 * 1000);
        expires = "; expires=" + date.toUTCString();
      }
      document.cookie = `${this.COOKIE_NAME}=${this.COOKIE_VALUE}${expires}; path=/`;
    }

    return isCookieSet;
  }

  // Function to check and display next banner
  displayNextBanner() {
    const isCookieSet = this.checkAndSetCookie();

    for (let i = 0; i < this.CHILD_SEGMENTS.length; i++) {
      const item = this.CHILD_SEGMENTS[i];
      const utmType = item.dataset.utmType;
      const utmTag = this.URL_PARAMS.get(utmType);
      const displayPage = item.dataset.displayPage;
      const displayUtmTag = item.dataset.displayUtmTag;
      const displaySource = item.dataset.displaySource;
      const displayAll = item.dataset.displayAll;

      let shouldDisplay = false; // Start with the assumption the banner should NOT display
      let pageMatch = false;

      if (displayPage == "") {
        pageMatch = true;
      } else if (
        displayPage &&
        this.CURRENT_PAGE_HANDLE.includes(displayPage)
      ) {
        pageMatch = true;
      }

      // Logic Checks - Set shouldDisplay to true ONLY if MATCH
      if (displayUtmTag && pageMatch && utmTag === displayUtmTag) {
        shouldDisplay = true;
      }

      if (
        displaySource &&
        pageMatch &&
        this.REFERRAL_SOURCE === displaySource
      ) {
        shouldDisplay = true;
      }

      if (displayAll == "true") {
        shouldDisplay = true;
      }

      if (shouldDisplay) {
        item.removeAttribute("hidden");
        if (isCookieSet) {
          item.classList.add("td-show-returning");
          console.log("Cookie is already set.");
        } else {
          item.classList.add("td-show-new");
          console.log("Cookie was not set, but it is now.");
        }
        break;
      }
    }
  }

  // Check if the entire section should be hidden
  checkAnyBannerDisplayed() {
    let anyBannerDisplayed = false;
    for (const item of this.CHILD_SEGMENTS) {
      if (!item.hasAttribute("hidden")) {
        anyBannerDisplayed = true;
        break;
      }
    }

    if (!anyBannerDisplayed) {
      const bannerSection = document.querySelector(".announcement-bar");
      if (bannerSection) {
        bannerSection.style.display = "none";
      }
    }
  }
}

customElements.define("td-origin-checker", TdOriginChecker);
